/**
 * Demo images for the patch configurator pages (PatchCard, TextCard,
 * ImageSelector, SinglePatch / GroupPatch). Downloaded from the Figma
 * components' sample fills and downscaled to ~2× their largest demo size.
 */

export const PATCH_BADDIE = require('@ajat/design-system/assets/configurator/patch-baddie.png');
export const PATCH_LETTER_A = require('@ajat/design-system/assets/configurator/patch-letter-a.png');
export const PATCH_SIGN = require('@ajat/design-system/assets/configurator/patch-sign.png');
export const PATCH_TEXT = require('@ajat/design-system/assets/configurator/text-thumb.png');

export const GROUP_PATCHES = [
  { id: 'butterfly', image: require('@ajat/design-system/assets/configurator/patch-butterfly.png'), imageAlt: 'Butterfly patch' },
  { id: 'heart', image: require('@ajat/design-system/assets/configurator/patch-heart.png'), imageAlt: 'Heart patch' },
  { id: 'star', image: require('@ajat/design-system/assets/configurator/patch-star.png'), imageAlt: 'Star patch' },
];
